






















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {WebService} from '@/services/web.service';
import {PhoneFormatter} from '@/services/phoneFormatter.service';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import {find} from 'lodash';

@Component({
	components: {
		typeahead: VueBootstrapTypeahead
	}
})
export default class PhoneInput extends Vue {
	@Prop({required: true})
	private phoneNumber!: string;

	@Prop({default: false})
	private focused!: boolean;

	@Prop({default: true})
	private autocomplete!: boolean;

	private phoneNumberInput = '';
	private customers = [];


	@Watch('phoneNumber')
	onPhoneNumberChange() {
		const cleaned = this.phoneNumber.replace(/[^0-9]/g, '');
		if(cleaned !== this.phoneNumber) {
			this.$emit('update:phoneNumber', cleaned);
		} else {
			this.phoneNumberInput = PhoneFormatter.format(this.phoneNumber, null);
			(this.$refs.customerPhone as any).inputValue = PhoneFormatter.format(this.phoneNumber, null);
		}
	}

	getMask(phone: string) {
		if(phone.replace(/[^0-9]/g, '').startsWith('1') || phone === '') {
			return '+D (DDD) DDD-DDDD';
		}
		return '(DDD) DDD-DDDD';
	}

	get phoneMask() {
		return this.getMask(this.phoneNumberInput);
	}

	get cleanedPhone() {
		return this.phoneNumberInput.replace(/[^0-9]/g, '');
	}

	@Watch('cleanedPhone')
	async phoneChange() {
		let localNumber = this.cleanedPhone;
		if(this.autocomplete) {
			if(!localNumber.startsWith('1')) {
				localNumber = '1' + localNumber;
			}
			if(localNumber.length >= 4) {
				this.customers = await WebService.searchCustomers(localNumber);
			} else {
				this.customers = [];
			}
		}

		if(this.phoneNumber !== this.cleanedPhone) {
			this.$emit('update:phoneNumber', this.cleanedPhone);
		}

		if(this.autocomplete) {
			const foundCustomer = find(this.customers, {phone: localNumber});
			if(foundCustomer) {
				this.$nextTick(() => {
					this.$emit('customerSelected', foundCustomer);
				});
			}
		}
	}

	serializePhone(input: {phone: string}) {
		return PhoneFormatter.format(input.phone, this.cleanedPhone.startsWith('1'));
	}

	mounted() {
		this.onFocusedChange();
		this.onPhoneNumberChange();
		this.$nextTick(() => {
			setTimeout(() => {
				(this.$refs.customerPhone as any).$el.querySelector('input').inputMode = 'tel';
			}, 1);
		});
	}

	// This has to run about 2 times on 12.4 and I think only once on 13+
	// It's a bit of a janky fix but so is dealing with keyboard/focus on
	// iOS so...
	iOSScrollFix() {
		window.scrollTo({
			left: 0,
			top: 0
		});
		setTimeout(() => {
			if(window.scrollY !== 0) {
				this.iOSScrollFix();
			}
		}, 250);
	}

	@Watch('focused')
	onFocusedChange() {
		if(this.focused) {
			this.$nextTick(() => {
				(this.$refs.fakeInput as any).focus();
				setTimeout(() => {
					(this.$refs.customerPhone as any).$el.querySelector('input').focus();
					this.iOSScrollFix();
				}, 1);
			});
		}
	}
}
